import {
  MenuItemInInventory,
  RatePlanDetailsForEachDate
} from '../../../types/inventory'
import RenderRowValues from '../renderRows/RenderRowValues'
import useStyles from './styles/InventoryChannelRowMobile.styles'

interface InventoryChannelRowProps {
  channelData: RatePlanDetailsForEachDate[]
  hideZeroes: boolean
  occupancy: number | 'def'
  selectedInventoryFieldInRatePlan: MenuItemInInventory
  weekendIndexes: number[]
  defaultOccupancy: number
}

const InventoryChannelRow: React.FC<InventoryChannelRowProps> = ({
  channelData,
  hideZeroes,
  occupancy,
  selectedInventoryFieldInRatePlan,
  weekendIndexes,
  defaultOccupancy
  //   weekendIndexes,
  //   numberOfRatePlans,
  //   showRatePlans,
  //   setshowRatePlans
}) => {
  const classes = useStyles()

  return (
    <div className={classes.roomTypeRow}>
      {/* <div className={classes.rowNameContainer}>
        <Typography variant="h4" className={classes.rowName}>
          {getTranslate(name)}
        </Typography>

        <ArrowRightIcon className={[classes.channelArrowRight].join(' ')} />
      </div> */}
      {/* <div className={classes.dayContainer}>
          <Typography variant="h5">{getTranslate('AVAIL')}</Typography>
        </div> */}
      <div className={classes.avalabilitiesContainer}>
        <div className={classes.dayContainer} />

        <RenderRowValues
          rowData={channelData}
          hideZeroes={hideZeroes}
          occupancy={occupancy}
          selectedInventoryField={selectedInventoryFieldInRatePlan}
          weekendIndexes={weekendIndexes}
          defaultOccupancy={defaultOccupancy}
          // onSaveRowData={(newRowData) => {
          //   onSaveRowData(newRowData as InventoryRateplanType)
          // }}
        />
      </div>
    </div>
  )
}

export default InventoryChannelRow
